
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import tackSettings from '@/settings/tack-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselTack',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configTackId = computed(() => store.getters.configTackId)
    const configBodyId = computed(() => store.getters.configBodyId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configTackId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configBodyId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const tackId = renderPathService.formatConfig(configTackId.value, tackSettings.options)
        setRendering(tackId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(tackId: string | null | undefined) {
      if (!tackId) {
        console.error('cannot find tack id for RenderingRandselTack')
        imagePath.value = ''
        return
      }
      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'tack/' + tackId + '.png'
      let path = RenderingConstants.path + camPath + optionPath
      if(configTackId.value == "7") {
        path = RenderingConstants.path + camPath + 'tack/7/' + configBodyId.value + '.png'
      }
      imagePath.value = path
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })

    return {
      imagePath
    }
  }
})
